import { Tooltip, EventHelper } from "@bryntum/schedulerpro";

export const HasIconColumnTooltipMixin = (Base) => class extends Base {

  onLoad(project, otherParams) {
    this.project = project;
    this.otherParams = otherParams;

    // Create tooltip if it doesn't exist
    if (!this.tooltipInstance) {
      this.tooltipInstance = new Tooltip({
        forElement: this.grid.element,
        forSelector: this.getTooltipSelector(),
        allowOver: true,
        cls: "swivu-contact-tooltip",
        scrollable: true,
        getHtml: this.getTooltipContent.bind(this),
      });

      // Register cleanup on destroy
      this.on({
        destroy: this.onColumnDestroy,
        thisObj: this,
        once: true,
      });
    }
  }

  getTooltipContent({ activeTarget, tip }) {
    const record = this.grid.getRecordFromElement(activeTarget);
    if (!record) {
      tip.hide();
      return;
    }

    // Get items to display in tooltip
    const items = this.getTooltipItems(record);

    if (items && items.length) {
      // Set up click handler
      if (this.onTooltipClick) {
        this.onTooltipClick();
        this.onTooltipClick = null;
      }

      this.onTooltipClick = EventHelper.on({
        element: tip.element,
        click: (e) => this.handleTooltipClick(e, record),
        thisObj: this
      });

      // Return tooltip content
      return {
        children: [{
          tag: "div",
          class: "swivu-contact-tooltip-content",
          children: this.formatTooltipItems(items, record)
        }]
      };
    } else {
      tip.hide();
    }
  }

  onColumnDestroy() {
    if (this.tooltipInstance) {
      this.tooltipInstance.destroy();
    }
    if (this.onTooltipClick) {
      this.onTooltipClick();
      this.onTooltipClick = null;
    }
  }
};
